/** Calendar bounds, not a guarantee that IBKR has published a statement. */
export function ibDateBounds(now = new Date()) {
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
  const shift = (date: string, days: number) => new Date(Date.parse(date) + days * 86400000).toISOString().slice(0, 10);
  let recommended = shift(today, -1);
  while ([0, 6].includes(new Date(recommended).getUTCDay())) recommended = shift(recommended, -1);
  return { earliest: shift(today, -365), latest: shift(today, -1), recommended };
}
export function ibDateError(start?: string, end?: string, now = new Date()): string | undefined {
  if (!start && !end) return;
  if (!start || !end) return 'Choose both start and end dates.';
  if (![start, end].every(d => /^\d{4}-\d{2}-\d{2}$/.test(d) && Number.isFinite(Date.parse(d)) && new Date(d).toISOString().slice(0, 10) === d)) return 'Enter valid calendar dates.';
  const bounds = ibDateBounds(now);
  if (start > end) return 'Start date must be on or before end date.';
  if (end > bounds.latest) return 'Choose an end date before today in New York. IBKR statements for the current day are not ready.';
  if (start < bounds.earliest || (Date.parse(end) - Date.parse(start)) / 86400000 >= 365) return 'IBKR supports up to 365 days of history. Choose a more recent start date.';
}
